import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Configuration } from './configuration.model';
import { ConfigurationService } from './configuration.service';
import { Globals } from '../../config/globals';

@Injectable()
export class ConfigurationServiceImpl implements ConfigurationService {
    public configuration: Configuration;

    constructor(private http: Http, private globals: Globals) {
        this.configuration = globals.getConfig();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/configuration-impl.service.ts